import { getSessionStorage } from '@bingads-webui/storage';
import { getEntityFromScope } from '@bingads-webui/edm-campaign';

export const storeSeasonalityAdjustmentName = ({ id, name }) => {
  getSessionStorage().set(`SeasonalityAdjustmentNameAndId${id}`, name);
};

export const getSeasonalityAdjustmentName = id => getSessionStorage().get(`SeasonalityAdjustmentNameAndId${id}`);

export const seasonalityPredicateValueNameGetter = name =>
  (name === 'SeasonalityAdjustmentId' || name === 'DataExclusionId'
    ? (item) => {
      const seasonalityName = getSessionStorage().get(`SeasonalityAdjustmentNameAndId${item}`);

      if (!seasonalityName) {
        return item;
      }
      return seasonalityName;
    } : undefined);

// Data exclusion is a special "SeasonalityAdjustment"
const getSeasonalityAdjustmentLike = ({ id, scope, jsdata }) => {
  const { currentAccount } = getEntityFromScope(scope);
  return jsdata.SeasonalityAdjustment.find(
    id,
    {
      entitySet: currentAccount.SeasonalityAdjustments,
      queryParameters: {
        query: {
          $select: 'Name',
        },
      },
    }
  );
};

export const updateSeasonalityNameFromMT = ({
  id, scope, i18n, jsdata,
}) => getSeasonalityAdjustmentLike({ id, scope, jsdata }).then((response) => {
  storeSeasonalityAdjustmentName({ id, name: response.Name });
}).catch(() => {
  storeSeasonalityAdjustmentName({ id, name: i18n.getString(_TL_('(deleted)')) });
});
